const DE = {
  governmentalOrganization: [
    "Stiftung des öffentlichen Rechts",
    "Anstalt des öffentlichen Rechts"
  ],
  listedPublicCompany: [
    "Aktiengesellschaft (AG)",
    "societas Europaea (SE)"
  ],
  nonProfit: [
    "gemeinnützige Gesellschaft mit beschränkter Haftung (gGmbH)",
    "gemeinnützige Unternehmergesellschaft (gUG)",
    "Stiftung"
  ],
  privateCompany: [
    "Gesellschaft mit beschränkter Haftung (GmbH)",
    "Unternehmergesellschaft (UG)",
    "kleine Aktiengesellschaft (AG)"
  ]
};
export {
  DE as default
};
